import { KioskTimerStart } from '../constants';
import { IConfigKiosk, IResponseConfigKiosk } from '../types';
import { transformToHexColorString } from '~/utils/formatter';
import { TBooleanInNumber } from '~/types/main';

export const configKioskDataCast = (data: IResponseConfigKiosk): IConfigKiosk => {
  const colors = data.colors;
  const images = data.images;
  const config = data.configuration;

  return {
    colors: {
      theme: colors.theme,
      mainColor: colors.main_color || '',
    },
    images: {
      bannerImage: images.kiosk_screen_image || '',
    },
    configuration: {
      timeStart: String(config.kiosk_timer_select) as KioskTimerStart,
      smsConfirmation: Number(config.kiosk_sms_checkbox) as TBooleanInNumber,
      message: { en: config.kiosk_sms_textarea_en, ar: config.kiosk_sms_textarea_ar },
      accessCode: String(config.on_kiosk_password),
    },
  };
};

export const getConfigKioskParams = (currentData: IConfigKiosk, previousData: IConfigKiosk) => {
  const curColors = currentData.colors;
  const curImages = currentData.images;
  const curConfig = currentData.configuration;

  const prevImages = previousData.images;

  return {
    theme: undefined,
    main_color: transformToHexColorString(curColors.mainColor),
    kiosk_screen_image: prevImages.bannerImage === curImages.bannerImage ? undefined : curImages.bannerImage || null,
    kiosk_timer_select: curConfig.timeStart,
    kiosk_sms_checkbox: curConfig.smsConfirmation,
    kiosk_sms_textarea_en: curConfig.message.en,
    kiosk_sms_textarea_ar: curConfig.message.ar,
    on_kiosk_password: curConfig.accessCode,
  };
};
